/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useContext, useRef, useState, useEffect } from 'react'
import OrdersTopBar from './components/OrdersTopBar'
import Table from './components/Table'
import { OrdersList, HandleOrderCategories } from './components/OrdersSlice'
import GlobalContext from '../../components/Context/GlobalContext'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useSearchParams } from 'react-router-dom'
import { dataService } from '../../services/data.services'
import Pagination from '../../components/Pagination'
import moment from 'moment'
import CardHeaders from '../../components/CardHeaders'
import CardHeader from '../../components/CardHeader'

export default function CustomerOrders(props) {
    const [isOpen, setIsOpen] = useState(false)
    const dependancy = useSelector(state => state.Dependancy)

    const { setToastmessage, toastErrorMessage, setToastErrorMessage, setToastError } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const Orders = useSelector(state => state.Orders);
    const { List, loading, error, Categories, } = Orders;
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({ });
    const [submitSelected, setSubmitSelected] = useState(false);
    const [exportloading, setExportloading] = useState(false);
    const [notFound, setNotFound] = useState(false);

    const isInitialRender = useRef(null);

    if (Object.keys(Object.fromEntries(searchParams)).length === 0) {
        setSearchParams({page_number:  1 });
    }

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const initialDate = {
        create_start: '',
        create_end: '',
        update_start: '',
        update_end: ''
    }
    const initialDateError = {
        create_start: '',
        create_end: '',
        update_start: '',
        update_end: ''
    }
    const [DateRange, SetDateRange] = useState(initialDate);
    const [DateRangeError, SetDateRangeError] = useState(initialDateError)

    // const [isLoading, setIsLoading] = useState(loading);

    // useEffect(() => {
    //     setIsLoading(loading);
    // },[loading])

    const handleSetDate = (key, value) => {
        SetDateRangeError(initialDateError)
        const dateCopy = { ...DateRange }
        dateCopy[key] = value;
        SetDateRange(dateCopy)
    }

    const handleDatePickerValidation = () => {
        let error = []
        const errorState = { ...DateRangeError }
        Object.keys(DateRangeError).map((item) => {
            switch (true) {
            case item === 'create_start' && DateRange['create_end'] === '':
                // eslint-disable-next-line indent
                    // eslint-disable-next-line indent
                    if (DateRange[item] !== '' && DateRange['create_end'] === '') {
                    errorState['create_end'] = 'End date is required'
                    error.push(item)

                }
                break

            case item === 'create_end' && DateRange['create_start'] === '':
                if (DateRange[item] !== '' && DateRange['create_start'] === '') {
                    errorState['create_start'] = 'Start date is required'
                    error.push(item)

                }
                break
            case item === 'update_start' && DateRange['update_end'] === '':
                if (DateRange[item] !== '' && DateRange['update_end'] === '') {
                    errorState['update_start'] = 'End date is required'
                    error.push(item)

                }
                break
            case item === 'update_end' && DateRange['update_start'] === '':
                if (DateRange[item] !== '' && DateRange['update_start'] === '') {
                    errorState['update_start'] = 'Start date is required'
                    error.push(item)

                }
                break
            case DateRange['create_start'] !== '' && DateRange['create_end'] !== '':

                if ((DateRange['create_start'] !== '' && DateRange['create_end'] !== '') && !moment(DateRange['create_start']).isSameOrBefore(moment(DateRange['create_end']))) {
                    errorState['create_start'] = 'End date should be greater than start date'
                    error.push(item)

                }
            case DateRange['update_start'] !== '' && DateRange['update_end'] !== '':

                if ((DateRange['update_start'] !== '' && DateRange['update_end'] !== '') && !moment(DateRange['update_start']).isSameOrBefore(moment(DateRange['update_end']))) {
                    errorState['update_start'] = 'End date should be greater than start date'
                    error.push(item)
                }
            }
        })
        SetDateRangeError(errorState)
        return error.length > 0
    }


    const handleApplyFilter = (status, clear, paymentType, store) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (clear) {
            if(!(params?.payment_status || params?.create_start || params?.create_end || params?.payment_type || params?.store_email_address)){
                return;
            }
            SetDateRange(initialDate);
            delete params.payment_status
            delete params.create_start
            delete params.create_end
            delete params.payment_type
            delete params.store_email_address
            SetDateRangeError(initialDateError)
            setSearchParams({ ...params })
            return
        }
        if (DateRange['create_start'] !== '' && DateRange['create_end'] !== '') {
            params.create_start = moment(DateRange['create_start']).unix()
            params.create_end = moment(DateRange['create_end']).unix()
        }
        // if(status === '') {
        //     delete params.status;
        //     setSearchParams(params);
        // } else {
        //     params.status = status;
        //     getSearchParamDetail(searchParams, setSearchParams, {status: status})
        // }
        if (status !== '') {
            params.payment_status = status
        } else {
            delete params.payment_status
        }
        if(paymentType !== ''){
            params.payment_type = paymentType
        }else{
            delete params.payment_type
        }  
        if(store !== ''){
            params.store_email_address = store
        }else{
            delete params.store_email_address
        }        
        SetDateRangeError(initialDateError)
        setSearchParams({ ...params })
    }

    const handleSearchParams = (key, value, del) => {
        let params = Object.fromEntries(searchParams);
        if (del) {
            delete params[del]
        } else {
            params.page_number = 1
            if (key === 'search') params[key] = encodeURIComponent(value)
            else params[key] = value
            if (params.search === '') delete params.search
        }
        setSearchParams({ ...params })
    }

    const handleFilters = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        // params.filter = true
        if (key === 'all') {
            delete params['filter'];
            delete params['status'];
        }
        else params[key] = value
        setSearchParams({ ...params })
    }

    function objectToQueryString(obj) {
        const keys = Object.keys(obj);
        let str = ''
        const keyValuePairs = keys.map((key, i) => {
            str += `${i === 0 ? `?` : '&'}${encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])}`;
        });
        return str
        // more code goes here
    }

    useEffect(() => {
        let params = Object.fromEntries(searchParams);
        if(List?.data?.length !== 0 ){
            setNotFound(false);
            params.page_number = 1;
        }
    },[List]);
    
    const GetList = useCallback(async () => {
        let params = Object.fromEntries(searchParams);
        delete params.tab
        try {
            params = objectToQueryString(params);
            if(Object.keys(params).length>0) {
                dispatch(OrdersList(params))
            }
        } catch (error) {
            // handleLoadData()
        }
    }, [searchParams]);

    useEffect(() => {
        let params = Object.fromEntries(searchParams);
        if (isInitialRender.current) {
            window.history.replaceState({}, '', window.location.pathname);
            params.page_number = 1;
            isInitialRender.current = false; // Signal subsequent renders
        }
        GetList();
        const copyDate = { ...DateRange }
        if ((params['create_start'] && params['create_end']) && params['create_start'] !== '' && params['create_end'] !== '') {
            copyDate.create_start = new Date(params['create_start'] * 1000)
            copyDate.create_end = new Date(params['create_end'] * 1000)
        }
        if ((params['update_start'] && params['update_end']) && params['update_start'] !== '' && params['update_end'] !== '') {
            copyDate.update_start = new Date(params['update_start'] * 1000) || ''
            copyDate.update_end = new Date(params['update_end'] * 1000) || ''
        }
        SetDateRange(copyDate)
    }, [GetList, dependancy])

    const handleExport = async () => {
        let params = Object.fromEntries(searchParams);
        delete params.page_number
        const body = { ...params }
        let search = ''
        search = searchParams.get('search');
        params = objectToQueryString(params);
        try{
            setExportloading(true);
            const res = await dataService.GetAPI(`orders/export-csv${params}`)
            if (!res.error) {
                window.open(
                    res.data.url,
                    '_blank'
                );
                // window.location.href = res.data.url
                setToastmessage('Orders exported successfully');
                setExportloading(false)
            }
        }catch(error){
            setToastError('An Error Occured!');
            setExportloading(false);
        }
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
   
    useEffect(() => {
        if(error){
            if(error?.response?.status === 400){
                setNotFound(true);
            }else{
                setToastError('An Error Occured!');
            }
        }
    },[error])

    /// Dont remove the below code it is being used
    const param = Object.fromEntries(searchParams);


    return (
        <CardHeader header={'Orders / Purchases'} noIcon>
            <div className='bg-[#f5f5f5] px-[16px] py-[12px] mt-[110px] '>
                <div className='h-customh10 bg-white rounded'>
                    <>
                        <OrdersTopBar
                            notFound={notFound}
                            isFilter
                            searchText="Order Number, Email Address"
                            sidePane={setIsOpen}
                            handleFilters={handleFilters}
                            SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                            handleOnClickSearch={handleSearchParams}
                            searchParams={searchParams}
                            setSearchParams={setSearchParams}
                            handleSetDate={handleSetDate}
                            DateRange={DateRange}
                            SetDateRange={SetDateRange}
                            handleApplyFilter={handleApplyFilter}
                            testid='add-btn'
                            setsubmitSelected={setSubmitSelected}
                            handleExport={handleExport}
                            DateRangeError={DateRangeError}
                            exportloading={exportloading}
                            SetDateRangeError={SetDateRangeError}
                            handleDatePickerValidation={handleDatePickerValidation}
                            DateErrorClear={() => SetDateRangeError(initialDateError)
                            }
                        />
                        <div className='bg-white h-fit rounded-b'>
                            <Table
                                notFound={notFound}
                                error={error}
                                loading={loading}
                                searchParams={searchParams}
                                handleSearchParams={handleSearchParams}
                                DateRange={DateRange}
                                initialDate={initialDate}
                            />
                        </div>
                        {!loading && Math.ceil(List.total_count / 10) > 1 && (!(List?.data?.length === 0 && !(param.search || param.status || param.payment_type || param.create_start || param.create_end))) &&
                        <Pagination selectedPageNumber={searchParams.get('page_number')} handleOnClickPageNumber={handleOnClickPageNumber} TotalCount={List.total_count} totalPageNumber={Math.ceil(List.total_count / 10)} />}
                    </>
                </div>
            </div>

        </CardHeader >
    )
}
